import { Box, IconButton, Menu } from '@mui/material';
import React, { useMemo } from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import Button from './Button';
import { get } from 'lodash';
import CustomInput from './fields/input';

const MultiPricePopup = ({ t, selectedCategories = [], clickSubmit = () => '', errors, register }) => {
    const prices = useMemo(() => new Array(get(selectedCategories, '[0].maxNumberOfGuest', 0)).fill('price'), [selectedCategories]);

    return (
        <PopupState variant="popover" popupId="multiprice-edit-popup-menu">
            {(popupState) => (
                <React.Fragment>
                    <IconButton size="large" disabled={selectedCategories.length !== 1} {...bindTrigger(popupState)}>
                        <AccountCircleIcon
                            sx={{
                                width: '1.3em',
                                height: '1.3em',
                                fontSize: '1.1em',
                            }}
                        />
                    </IconButton>

                    <Menu PaperProps={{ className: 'multiprice-modal-container' }} {...bindMenu(popupState)}>
                        <Box className="multiprice-modal beauty_scrollbar">
                            <div className="line">
                                <div className="line-item">{t('COUNT')}</div>
                                <div className="line-item">{t('PRICE')}</div>
                            </div>
                            {prices.map((item, i) => (
                                <div className="line" key={i}>
                                    <div className="line-item title">{i + 1}</div>
                                    <CustomInput
                                        name={`value.priceByGuests.${i}`}
                                        errors={errors}
                                        type="number"
                                        className="table-input"
                                        style={{
                                            maxWidth: '140px',
                                            marginBottom: '0',
                                        }}
                                        register={register(`value.priceByGuests.${i}`, {
                                            min: {
                                                value: 0.001,
                                                message: t('VALUE_MUST_BE_GREATER_THAN_ZERO'),
                                            },
                                        })}
                                    />
                                </div>
                            ))}
                            <div className="multiprice-modal-footer">
                                <Button onClick={clickSubmit}>{t('SAVE')}</Button>
                            </div>
                        </Box>
                    </Menu>
                </React.Fragment>
            )}
        </PopupState>
    );
};

export default MultiPricePopup;
